<template>
	<div name="hrms15e-popup-course3" id="hrms15e-popup-course3" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
		  <div class="modal-content">
		    <div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		      <h4 class="modal-title">{{ labels['HRAP31EC32']['160'] }}</h4>
		    </div>
		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
            <hrms-table :columns="courseGapPopupTable" 
                        :data="popupCourseGap"
                        :searchDisp="false" 
                        :selectRowBool="false"
                        :selectBtnDisp="true"
                        :selectEvent="selectEvent"
                        :confirmSelectBtnDisp="false"
                        ref="popupCourse" />

					</div>
				</div>
				<div class="modal-footer" >
          <button type="button" class="btn bg-color-skin pull-left" data-dismiss="modal" @click="triggerCourse()"><i class="fa fa-check-circle"></i>{{ labelsButton['ok'] }}</button>
	      </div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'hrms15e-popup-course3',
  props: [ 'labels', 'labelsButton', 'popupCourseGap', 'courseGapPopupTable', 'setDetailCouresAddInlineAll' ],
  methods: {
    triggerCourse () {
      this.$refs.popupCourse.$emit('$selectEventBuiltIn')
    },
    selectEvent (checkedDataRows) {
      this.setDetailCouresAddInlineAll(checkedDataRows)
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupCourseGap3.vue?4d35742e